// Fontaine M21 — date-only helpers shared by DatePicker (and its tests). Dates are "YYYY-MM-DD" strings.
import { toDateOnly } from "../../core/dateOnly";

export const pad2 = (n) => String(n).padStart(2, "0");
export const MONTHS_SHORT = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const MONTHS_LONG = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
export const DOW = ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"];
export const daysIn = (m, y) => new Date(y, m + 1, 0).getDate();

export const isoToParts = (iso) => {
  const m = typeof iso === "string" && iso.match(/^(\d{4})-(\d{2})-(\d{2})/);
  return m ? { y: +m[1], m: +m[2] - 1, d: +m[3] } : null;
};
export const partsToIso = ({ y, m, d }) => `${y}-${pad2(m + 1)}-${pad2(d)}`;
/** "DD-MM-YYYY" (also accepts / and .) → ISO or null */
export const parseDisplay = (text) => {
  const m = String(text || "").trim().match(/^(\d{1,2})[-/.](\d{1,2})[-/.](\d{4})$/);
  if (!m) return null;
  const d = +m[1], mo = +m[2] - 1, y = +m[3];
  if (mo < 0 || mo > 11 || d < 1 || d > daysIn(mo, y)) return null;
  return partsToIso({ y, m: mo, d });
};
export const formatDisplay = (iso) => {
  const p = isoToParts(iso);
  return p ? `${pad2(p.d)}-${pad2(p.m + 1)}-${p.y}` : "";
};
export const cmp = (a, b) => (a < b ? -1 : a > b ? 1 : 0);
export const clampIso = (iso, min, max) => (min && iso < min ? min : max && iso > max ? max : iso);
export const todayIso = () => toDateOnly(new Date());

